import { PageRef } from 'providers/page-ref';
import { FoodHeader } from '@cf-shared/data-model/food';

/** One extracted ingredient that the user matched to a DB food on the results screen. */
export interface RecipeScannerMatchedIngredient {
  aiName: string;
  estimatedGrams: number;
  confidence: number;
  food: FoodHeader;        // matched DB food
  /** set when the user ticked "Weighed with peel" on the portion screen (#5544); estimatedGrams is then the eaten weight */
  weighedWithRefuse?: { percent: number };
}

export type RecipeScannerPageParams = {
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

/** The in-memory recipe draft handed back to the Create Recipe page. Nothing is
 *  saved by the scanner — the page applies this to its in-memory food object. */
export type RecipeScannerResult = {
  name?: string;
  servings?: number;
  instructions?: string;
  matchedIngredients: RecipeScannerMatchedIngredient[];
};

export const IRecipeScannerPage: PageRef<RecipeScannerPageParams, RecipeScannerResult> = {
  pageName: 'RecipeScannerPage',
} as PageRef<RecipeScannerPageParams, RecipeScannerResult>;

// In-memory hand-off for the chosen cooked-dish photo (the recipe image). Mirrors
// edit-food-interface's pendingLabelScanImage: the data URL is too large for the
// NavController return params, so the scanner stashes it here and onRecipeScanResult
// consumes + clears it. Null when no cooked-dish photo was identified.
export let pendingRecipeScanImageDataUrl: string | null = null;
export function setPendingRecipeScanImage(dataUrl: string | null) {
  pendingRecipeScanImageDataUrl = dataUrl;
}
